// extracted by mini-css-extract-plugin
module.exports = {"header__cart-empty-container":"HeaderCartEmptyMessage_header__cart-empty-container__n2adT","header__cart-empty-text":"HeaderCartEmptyMessage_header__cart-empty-text__5WC9_"};